<dds-button theme="green" size="md" kind="secondary" (click)="reset()">
  Reset
</dds-button>
<dds-button theme="green" size="md" kind="secondary" (click)="close()">
  Cancel
</dds-button>
<dds-button
  type="submit"
  [disabled]="!form?.valid || !form.get('dateRange')?.value"
  (click)="onApply()"
>
  Apply
</dds-button>
